import * as React from 'react';

import ActionButton from 'components/buttons/action-button/ActionButton';

import { __t, applyTranslations } from 'utils/language';

import './client-approval-entry-actions.scss';

applyTranslations(require('locales/common/collabary-common.i18n.json'));

type Props = {
  onApprove: () => void,
  onDecline: () => void
};

const ClientApprovalEntryActions: React.FC<Props> = ({ onApprove, onDecline }: Props) => (
  <div className="client-approval-entry-actions">
    <div className="client-approval-entry-actions__button">
      <ActionButton
        width="small"
        height="minimum"
        style="small"
        color="tertiary"
        onClick={onDecline}
      >
        {__t('collabary_common.action_button.decline')}
      </ActionButton>
    </div>
    <div className="client-approval-entry-actions__button">
      <ActionButton
        width="small"
        height="minimum"
        style="small"
        color="primary"
        onClick={onApprove}
      >
        {__t('collabary_common.action_button.approve')}
      </ActionButton>
    </div>
  </div>
);

export default ClientApprovalEntryActions;
